import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

export class PostArenaSubmissionUseCase {
  constructor(private judgeRepository: JudgeRepository) {}

  async postArenaSubmission(
    arenaProblemId: string,
    arenaId: string,
    programLanguage: ProgramLanguageType,
    sourceCode: string
  ): Promise<string> {
    try {
      const data = await this.judgeRepository.postArenaSubmission(arenaProblemId, arenaId, programLanguage, sourceCode)
      return data
    } catch (error) {
      console.error(`Error in PostArenaSubmissionUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
